// Shared geometry helpers for positioning portaled UI (menus, tooltips, popovers)
// within the browser viewport. Consolidates the "flip and clamp to viewport" math
// that previously lived independently in the menu, Tooltip, and CitationBadge components.

// Default gap to keep between a portaled element and the viewport edge.
export const VIEWPORT_MARGIN = 8;

// Clamp a 1D coordinate so an element of `size` stays within
// [margin, viewportSize - margin]. When the element is larger than the available
// space, it pins to `margin`.
export function clampToViewport(pos: number, size: number, viewportSize: number, margin: number = VIEWPORT_MARGIN) {
  const max = viewportSize - size - margin;
  return Math.min(Math.max(pos, margin), Math.max(margin, max));
}

// Does an element of `size` fit before `edge` (above it / to its left) within the viewport?
export function fitsBefore(edge: number, size: number, margin: number = VIEWPORT_MARGIN) {
  return edge - size - margin >= 0;
}

// Does an element of `size` fit after `edge` (below it / to its right) within the viewport?
export function fitsAfter(edge: number, size: number, viewportSize: number, margin: number = VIEWPORT_MARGIN) {
  return edge + size + margin <= viewportSize;
}
